import { render, staticRenderFns } from "./exhibitDetail.vue?vue&type=template&id=3228aa6d&scoped=true"
import script from "./exhibitDetail.vue?vue&type=script&lang=js"
export * from "./exhibitDetail.vue?vue&type=script&lang=js"
import style0 from "./exhibitDetail.vue?vue&type=style&index=0&id=3228aa6d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3228aa6d",
  null
  
)

export default component.exports